import styled from 'styled-components';
import {NavLink, TabContent} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export const NavLinkStyled = styled(NavLink)`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: #858C9A !important;
  .nav-link&.active{
    color: #2E394F !important;
  }
  cursor: pointer;
`;
export const HostedTagContainer = styled.div`
  padding: .8rem!important;
  min-height: 350px;
  flex: 1;
`;
export const TotalCharge = styled.div`
  border-radius: 0px 0px 4px 4px;
  font-size: 13px;
  // padding: 2%;
  font-weight: 600;
`;

export const TabContentStyled = styled(TabContent)`
  height: 344px;
  @media (max-width: 665px) {
    height: 285px;
  }
  @media (min-width: 666px) and (max-width: 685px) {
    height: 322px;
  }
   @media (min-width: 1100px) and (max-width: 1280px) {
    height: 285px;
  }   
  @media (min-width: 1281px) and (max-width: 1422px) {
    height: 324px;
  }
  @media (min-width: 1590px) {
    height: 329px;
  }
  border-radius: 7px;
  margin-top: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  background: #F8F8F8;
`;
export const TextInfo = styled.p`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: ${props => props.subText ? 'normal' : 'bold'};
  font-size: 13px;
  line-height: 17px;
  color: #27364E;
  text-align: left;
  padding-left: 10px;
  padding-top: ${props => props.subText ? '5px' : '16px'};
  margin-bottom: 0 !important;
`;
export const NHSButtonContainer = styled.button`
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  box-sizing: border-box;
  border-radius: 4px;
  color: ${props => (props.dropDownColor && props.dropDownColor === 'lightBlue') ? '#41B6E6' : props.dropDownColor} ;
  display: flex;
  font-family: Titillium Web;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  height: 25px;
  line-height: 19px;
  margin-left: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
  i{
  margin-right: 5px;
  }
`;
export const TagIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  padding-right: 5px;
`;
export const TypesContainer = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  justify-content: left;
  margin-top: 1rem;
  text-align: left;
  margin-right: ${props => props.marginRequired && '1.5rem'}
`;
export const TextContainer=styled.div`
  margin-top: 7px;
  padding-left: 10px;
`;
export const TagsTabContainer = styled.div`
  margin-right: 1rem;
`;
export const TypesHeading = styled.p`
  display: inline;
  font-family: Titillium Web;
  font-style: normal;
  font-weight: ${props => props.subText ? 'normal' : 'bold'};
  font-size: 13px;
  line-height: 17px;
  color: ${props => props.colored ? '#48ADE7' : '#27364E'};
  padding-left: ${props => props.subText ? '5px' : ''};
  text-align: left;
  padding-top: ${props => props.subText ? '' : '16px'};
  margin-bottom: 0.5 !important;
  a{
  color: #48ADE7 !important;
  text-decoration: underline;
  }
`;
export const IndHeading = styled(TypesHeading)`
  color: #008000;
`;
export const WhomeHeading = styled(TypesHeading)`
  color: #EA233E;
`;
export const CampHeading = styled(TypesHeading)`
  color: #FFA500;
`;
export const BlessingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 10% 0;
`;

